module.exports = __webpack_public_path__ + "registration-ic.svg?52f439379b7ec7ca2acbd58252d99c3d";